import { Video, Monitor, FileText, CirclePlay, Languages, Users } from "lucide-react"
import { useTranslation } from "@/clientWeb/i18n/LanguageContext"

export default function About() {
  const t = useTranslation()
  return (
    <div className="space-y-4 flex flex-col h-full animate-in fade-in slide-in-from-bottom-4 duration-500">
      {/* Page Header */}
      <div className="flex flex-col">
        <h2 className="text-xl font-bold text-slate-900 dark:text-foreground/80 dark:text-white">
          {t("about.title")}
        </h2>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">
          {t("about.subtitle")}
        </p>
      </div>
      <div className="flex flex-col gap-4 flex-1">
        {/* App Info Card */}
        <div className="bg-gradient-to-br from-primary/10 to-primary/5 rounded-2xl p-4 border border-primary/10">
          <div className="flex items-start gap-4">
            <div className="w-20 h-20  flex items-center justify-center">
              <img src="/in.svg" alt="" className="w-full h-full" />
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-slate-900 dark:text-foreground/80 dark:text-white">
                InMeet
              </h3>
              <p className="text-slate-600 dark:text-slate-400">
                {t("about.version")}
              </p>
              <p className="text-slate-700 text-xs dark:text-slate-300 leading-relaxed">
                {t("about.description")}
              </p>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="bg-card dark:bg-card rounded-2xl shadow-xs border border-stroke-100 dark:border-border dark:border-border p-4">
          <h3 className="text-md font-semibold text-slate-900 dark:text-foreground/80 dark:text-white mb-4">
            {t("about.keyFeatures")}
          </h3>
          <div className="grid gap-4 md:grid-cols-2">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Video className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t("about.hdVideoAudio")}
                </p>
                <p className="text-xs pt-1 text-slate-600 dark:text-slate-400">
                  {t("about.hdVideoAudioDesc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Monitor className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t("about.screenSharing")}
                </p>
                <p className="text-xs pt-1 text-slate-600 dark:text-slate-400">
                  {t("about.screenSharingDesc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <FileText className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t("about.aiTranscription")}
                </p>
                <p className="text-xs pt-1 text-slate-600 dark:text-slate-400">
                  {t("about.aiTranscriptionDesc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <CirclePlay className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t("about.recording")}
                </p>
                <p className="text-xs pt-1 text-slate-600 dark:text-slate-400">
                  {t("about.recordingDesc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Languages className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t("about.multiLanguage")}
                </p>
                <p className="text-xs pt-1 text-slate-600 dark:text-slate-400">
                  {t("about.multiLanguageDesc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Users className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t("about.telepresenceRooms")}
                </p>
                <p className="text-xs pt-1 text-slate-600 dark:text-slate-400">
                  {t("about.telepresenceRoomsDesc")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Copyright */}
      <div className="text-center pt-6">
        <p className="text-slate-600 dark:text-slate-400">
          {t("about.copyright")}
        </p>
        <p className="text-sm text-slate-500 dark:text-foreground mt-2">
          {t("about.madeWithLove")}
        </p>
      </div>
    </div>
  )
}
